module.exports = __webpack_public_path__ + "static/icons/icon-sandbar--green-894d5ba684c612498a687a2f63351730.svg";